// The user-facing error label for an image's provenance, or null when the image
// raises no error. A rejected duplicate and a missing file are the two error
// provenances; everything else (including a not-yet-evaluated image) is clean.
// Worded for the user — never naming any internal detail.
const errorLabels = {
    rejected_duplicate: 'תמונה כפולה',
    missing: 'קובץ התמונה חסר',
}

export function imageErrorLabel(provenance) {
    return errorLabels[provenance] ?? null
}
